import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../../util/authContext';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import StylesThemeProvider from '@mui/styles/ThemeProvider';
import CircularProgress from "@mui/material/CircularProgress";
import { AlertProvider } from '../../util/alertDialogContext';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from '../../state/store';
import Root from "./Root";
import { Container } from '@mui/material';
import PwaUpdateNotification from '../PwaUpdateNotification';
import theme from "../theme";
import EtherealAlerts from "../EtherealAlerts";
import ErrorBoundary from './ErrorBoundary';
import AppInitializer from './AppInitializer';

const LoadingIndicator = () => (
  <Container maxWidth={"sm"} style={{height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
    <CircularProgress />
  </Container>
);

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <StylesThemeProvider theme={theme}>
              <PwaUpdateNotification /> {/* This component is critical for offline use */}
              <PersistGate persistor={persistor}
                           loading={<LoadingIndicator />}>
                <AuthProvider>
                  <AlertProvider>
                    <ErrorBoundary>
                      <AppInitializer>
                        <Root/>
                      </AppInitializer>
                    </ErrorBoundary>
                  </AlertProvider>
                  <EtherealAlerts />
                </AuthProvider>
              </PersistGate>
            </StylesThemeProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
